// src/components/reporting/cohort/cohortSetLabel.js
// A short name for a cohort selection: "Alpha", "Alpha, Beta", or
// "Alpha, Beta +2 more". Same wording as cohortSetLabel in the API's
// CohortThemesService, which titles the report and its discussion.
export default function cohortSetLabel(cohorts) {
  const names = cohorts.slice(0, 2).map((c) => c.name).join(', ');
  return cohorts.length > 2 ? `${names} +${cohorts.length - 2} more` : names;
}
